// Sort object keys recursively so semantically-equivalent JSON renders the
// same way on both sides of the diff (key reordering shouldn't show as a
// change).
const sortKeysDeep = (value: unknown): unknown => {
  if (Array.isArray(value)) {
    return value.map(sortKeysDeep);
  }
  if (value !== null && typeof value === 'object') {
    const entries = Object.entries(value as Record<string, unknown>).sort(
      ([a], [b]) => a.localeCompare(b)
    );
    return Object.fromEntries(entries.map(([k, v]) => [k, sortKeysDeep(v)]));
  }
  return value;
};

export const formatJson = (value: unknown) =>
  JSON.stringify(sortKeysDeep(value), null, 2);
